class IceClassType {
    public name: string = ""
    public code: string = ""
    public finum: number = 0
    public fisum: number = 0
}

export default IceClassType